export const playAudio = async (path: string) => {
  console.log(`Playing audio ${path}`);

  try {
    const audio = new Audio(path)
    window.focus()
    await audio.play()
  } catch (e) {
    console.error(e);
  }
}
